import styled from 'styled-components';
import { Typography } from '../../global/theme';
import { FlexCenter } from '../../global/commonStyle';

export const DesktopAppOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: var(--background-secondary);
  ${FlexCenter}
  z-index: var(--z-index-highest);
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    padding-bottom: var(--space-10);
  }
`;

export const Title = styled.div`
  ${Typography.body_lg}
  color: var(--text-primary);
  margin-bottom: var(--space-8);
`;

export const OpenHereButton = styled.button`
  background: transparent;
  border: none;
  ${Typography.body_lg}
  color: var(--text-link);
  text-decoration: underline;
  cursor: pointer;
  padding: var(--space-0);
  font: inherit;

  &:hover {
    text-decoration: none;
  }

  &:focus {
    outline: none;
    text-decoration: underline;
  }
`;
